import PropTypes from "prop-types";

import "./styles.css";

export default function Switch({ isOn, handleToggle }) {
  return (
    // eslint-disable-next-line jsx-a11y/label-has-associated-control
    <label className="slider">
      <input type="checkbox" onChange={handleToggle} checked={isOn} />
      <div className="sort" />
    </label>
  );
}

Switch.propTypes = {
  isOn: PropTypes.bool.isRequired,
  handleToggle: PropTypes.func.isRequired,
};
